import { Injectable } from '@angular/core';
import { LocalStorageWrapper } from 'angular-core-src';
import { Subject } from 'rxjs';

@Injectable()
export class LanguageService {
    private language = new Subject<string>();
    public language$ = this.language.asObservable();

    constructor() {}

    public changeLanguage(locale: string) {
        this.language.next(locale);
    }

    public getTranslationUrl() {
        const currentLang = LocalStorageWrapper.getLocale();
        switch (currentLang) {
            case 'en':
                return '/assets/i18n-datatable/en-GB.json';
            case 'es':
                return '/assets/i18n-datatable/es-ES.json';
        }

        return '/assets/i18n-datatable/en-GB.json';
    }
}
